module.exports = __webpack_public_path__ + "static/img/77.42417f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/77.png
// module id = jOyO
// module chunks = 0